<template>
    <div>
    <!-- Intro -->
    <div id="intro" class="basic-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="text-container">
                        <div class="section-title">ARQUERS</div>
                        <h2>Wa asd asdasd as dasd sad asdn Town</h2>
                        <p>Launching a new company or developing the market position of an existing one can be quite an overwhelming processs at times.</p>
                        <p class="testimonial-text">"Our mission here at Aira is to get you through those tough moments relying on our team's expertise in starting and growing companies."</p>
                        <div class="testimonial-author">Louise Donovan - CEO</div>
                    </div>
                    <!-- end of text-container -->
                </div>
                <!-- end of col -->
                <div class="col-lg-7">
                    <div class="image-container">
                        <img class="img-fluid" src="https://1.bp.blogspot.com/-qtb2vb2kLmY/WbGiojDz3wI/AAAAAAAADnM/283twQQTHGIC_jdpq7BkPmP-jL2IOCu8wCPcBGAYYCw/s1600/RUBI%2BARQUEROS.jpg" alt="">
                    </div>
                    <!-- end of image-container -->
                </div>
                <!-- end of col -->
            </div>
            <!-- end of row -->
        </div>
        <!-- end of container -->
    </div>
    <!-- end of basic-1 -->
    <!-- end of intro -->
    </div>
</template>

<script>
    export default {
        name: 'Intro',
        components: {
        }
    }
</script>